"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.cssAnchorName = exports.ProductAreaFilter = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preactPortal = _interopRequireDefault(require("preact-portal"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _updateQueryFilters = require("@insided/destination/modules/Navigation/shared/updateQueryFilters");

var _ChevronUp = _interopRequireDefault(require("@insided/shared/icons/ChevronUp"));

var _ChevronDown = _interopRequireDefault(require("@insided/shared/icons/ChevronDown"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'ideation-product-area-filter'; // Iterate over children of productAreas to find the parent section id of the selected product area

exports.cssAnchorName = cssAnchorName;

function getParentSectionId(productAreas, productAreaId) {
  if (!productAreaId) {
    return null;
  }

  return productAreas.reduce(function (parentId, currentValue) {
    var _currentValue$childre, _currentValue$childre2, _currentValue$childre3;

    return (_currentValue$childre = (_currentValue$childre2 = currentValue.children) === null || _currentValue$childre2 === void 0 ? void 0 : (_currentValue$childre3 = _currentValue$childre2.find(function (area) {
      return area.id === Number(productAreaId);
    })) === null || _currentValue$childre3 === void 0 ? void 0 : _currentValue$childre3.parentId) !== null && _currentValue$childre !== void 0 ? _currentValue$childre : parentId;
  }, null);
} // Iterate over productAreas to find the selected product area


function getSelectedProductArea(productAreas, productAreaId) {
  return productAreas.reduce(function (acc, currentValue) {
    if (currentValue.id === Number(productAreaId)) {
      return currentValue;
    }

    if (currentValue.children) {
      var child = currentValue.children.find(function (area) {
        return area.id === Number(productAreaId);
      });

      if (child) {
        return child;
      }
    }

    return acc;
  }, null);
}

function addUniqueItem(arr, item) {
  return Array.from(new Set(arr).add(item));
}

var ProductAreaList = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductAreaList, _Component);

  var _super = _createSuper(ProductAreaList);

  function ProductAreaList() {
    var _this$props$selectedP;

    var _this;

    (0, _classCallCheck2.default)(this, ProductAreaList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      selectedProductArea: getSelectedProductArea(_this.props.productAreas, _this.props.selectedProductArea),
      selectedProductAreaBeforeFiltersApply: (_this$props$selectedP = _this.props.selectedProductAreaBeforeFiltersApply) !== null && _this$props$selectedP !== void 0 ? _this$props$selectedP : null,
      selectedProductAreaSectionId: Number(_this.props.selectedProductAreaSectionId) || null,
      openProductAreaSectionIds: _this.props.selectedProductAreaSectionId ? [Number(_this.props.selectedProductAreaSectionId)] : function () {
        var parentSectionId = getParentSectionId(_this.props.productAreas, _this.props.selectedProductArea);
        return parentSectionId !== null ? [parentSectionId] : [];
      }()
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setSelectedProductAreaSectionId", function (sectionId) {
      _this.setState(function (prevState) {
        return {
          selectedProductArea: null,
          selectedProductAreaSectionId: sectionId,
          openProductAreaSectionIds: sectionId ? addUniqueItem(prevState.openProductAreaSectionIds, sectionId) : prevState.openProductAreaSectionIds
        };
      }, function () {
        return (0, _updateQueryFilters.updateQueryFilters)({
          productAreaSectionId: sectionId
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setSelectedProductArea", function (newProductArea, e) {
      e === null || e === void 0 ? void 0 : e.stopPropagation();

      _this.setState({
        selectedProductArea: newProductArea,
        selectedProductAreaSectionId: null
      }, function () {
        (0, _updateQueryFilters.updateQueryFilters)({
          productArea: newProductArea !== null && newProductArea !== void 0 && newProductArea.id ? [newProductArea.id] : null
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleSection", function (sectionId) {
      _this.setState(function (prevState) {
        var openProductAreaSectionIds = new Set(prevState.openProductAreaSectionIds);

        if (openProductAreaSectionIds.has(sectionId)) {
          openProductAreaSectionIds.delete(sectionId);
        } else {
          openProductAreaSectionIds.add(sectionId);
        }

        return {
          openProductAreaSectionIds: Array.from(openProductAreaSectionIds)
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "desktopQuery", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "syncSelectionFromUrl", function () {
      var _this$state$selectedP;

      var params = new URLSearchParams(window.location.search);
      var productAreaId = params.get('filters[productArea][0]');
      var productArea = productAreaId ? getSelectedProductArea(_this.props.productAreas, productAreaId) : null;

      if ((productArea === null || productArea === void 0 ? void 0 : productArea.id) !== ((_this$state$selectedP = _this.state.selectedProductArea) === null || _this$state$selectedP === void 0 ? void 0 : _this$state$selectedP.id)) {
        _this.setState({
          selectedProductArea: productArea,
          selectedProductAreaSectionId: null
        });
      }
    });
    return _this;
  }

  (0, _createClass2.default)(ProductAreaList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (typeof window === 'undefined') {
        return;
      }

      window.addEventListener('productAreaFilterRemoval', function () {
        return _this2.setSelectedProductArea(null);
      });
      window.addEventListener('revertFilters', function () {
        return _this2.setSelectedProductArea(_this2.state.selectedProductAreaBeforeFiltersApply);
      });
      window.addEventListener('filter', function (e) {
        return _this2.props.updatePortalSetting(e, _this2.state.selectedProductArea);
      });
      window.addEventListener('resetFilters', function () {
        return _this2.setSelectedProductArea(null);
      });
      this.desktopQuery = window.matchMedia('(min-width: 1025px)');
      this.desktopQuery.addEventListener('change', this.syncSelectionFromUrl);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this3 = this,
          _this$desktopQuery;

      if (typeof window === 'undefined') {
        return;
      }

      window.removeEventListener('productAreaFilterRemoval', function () {
        return _this3.setSelectedProductArea(null);
      });
      window.removeEventListener('revertFilters', function () {
        return _this3.setSelectedProductArea(_this3.state.selectedProductAreaBeforeFiltersApply);
      });
      window.removeEventListener('filter', function (e) {
        return _this3.props.updatePortalSetting(e, _this3.state.selectedProductArea);
      });
      window.removeEventListener('resetFilters', function () {
        return _this3.setSelectedProductArea(null);
      });
      (_this$desktopQuery = this.desktopQuery) === null || _this$desktopQuery === void 0 ? void 0 : _this$desktopQuery.removeEventListener('change', this.syncSelectionFromUrl);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var productAreas = this.props.productAreas;
      var _this$state = this.state,
          selectedProductArea = _this$state.selectedProductArea,
          selectedProductAreaSectionId = _this$state.selectedProductAreaSectionId,
          openProductAreaSectionIds = _this$state.openProductAreaSectionIds;
      return (0, _preact.h)("div", {
        className: (0, _classnames.default)('box__content', 'box__pad', 'product-area-filter', 'is-hidden-M')
      }, (0, _preact.h)("h3", {
        className: "widget-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "filter.by.product"
      })), (0, _preact.h)("ul", {
        className: "product-area-filter__product-areas-list"
      }, (0, _preact.h)("li", {
        className: "product-area-filter__title"
      }, (0, _preact.h)("div", {
        onClick: function onClick() {
          _this4.setSelectedProductArea(null);

          _this4.setSelectedProductAreaSectionId(null);
        },
        onKeyUp: function onKeyUp(e) {
          if (e.code === 'Enter') {
            _this4.setSelectedProductArea(null);

            _this4.setSelectedProductAreaSectionId(null);
          }
        },
        role: "button",
        className: (0, _classnames.default)('list-item-button', selectedProductArea === null && selectedProductAreaSectionId === null ? 'selected' : ''),
        tabIndex: 0
      }, (0, _preact.h)(_phrase.default, {
        p: "all.products"
      }))), productAreas.map(function (productArea) {
        var _productArea$children;

        return productArea.isSection ? (0, _preact.h)("li", {
          key: productArea.id,
          className: (0, _classnames.default)('product-area-filter__section', {
            open: openProductAreaSectionIds.includes(productArea.id)
          })
        }, (0, _preact.h)("div", {
          className: (0, _classnames.default)('list-item-button', selectedProductAreaSectionId === productArea.id ? 'selected' : '')
        }, Boolean((_productArea$children = productArea.children) === null || _productArea$children === void 0 ? void 0 : _productArea$children.length) && (0, _preact.h)(_phrase.default, {
          p: "accessibility_label.collapse",
          renderAsText: true
        }, function (accessibilityLabelCollapse) {
          return (0, _preact.h)(_phrase.default, {
            p: "accessibility_label.expand",
            renderAsText: true
          }, function (accessibilityLabelExpand) {
            return (0, _preact.h)("div", {
              onClick: function onClick() {
                return _this4.toggleSection(productArea.id);
              },
              onKeyUp: function onKeyUp(e) {
                return e.code === 'Enter' ? _this4.toggleSection(productArea.id) : null;
              },
              role: "button",
              "aria-label": openProductAreaSectionIds.includes(productArea.id) ? accessibilityLabelCollapse : accessibilityLabelExpand,
              "aria-expanded": openProductAreaSectionIds.includes(productArea.id),
              tabIndex: 0,
              className: "chevron-icon"
            }, openProductAreaSectionIds.includes(productArea.id) ? (0, _preact.h)(_ChevronUp.default, null) : (0, _preact.h)(_ChevronDown.default, null));
          });
        }), (0, _preact.h)("span", {
          onClick: function onClick() {
            return _this4.setSelectedProductAreaSectionId(productArea.id);
          },
          onKeyUp: function onKeyUp(e) {
            return e.code === 'Enter' ? _this4.setSelectedProductAreaSectionId(productArea.id) : null;
          },
          role: "button",
          tabIndex: 0,
          className: "product-area-filter__section-title"
        }, productArea.name)), productArea.children && openProductAreaSectionIds.includes(productArea.id) && (0, _preact.h)("ul", {
          className: "product-area-filter__product-areas-list"
        }, productArea.children.map(function (childProductArea) {
          return (0, _preact.h)("li", {
            key: childProductArea.id
          }, (0, _preact.h)("div", {
            onClick: function onClick(e) {
              return _this4.setSelectedProductArea(childProductArea, e);
            },
            onKeyUp: function onKeyUp(e) {
              return e.code === 'Enter' ? _this4.setSelectedProductArea(childProductArea, e) : null;
            },
            role: "button",
            className: (0, _classnames.default)('list-item-button', (selectedProductArea === null || selectedProductArea === void 0 ? void 0 : selectedProductArea.id) === childProductArea.id ? 'selected' : ''),
            tabIndex: 0
          }, (0, _preact.h)("div", {
            className: "vertical-line"
          }), (0, _preact.h)("span", null, childProductArea.name)));
        }))) : (0, _preact.h)("li", {
          key: productArea.id,
          className: (0, _classnames.default)('product-area-filter__title', (selectedProductArea === null || selectedProductArea === void 0 ? void 0 : selectedProductArea.id) === productArea.id && selectedProductAreaSectionId === null ? 'selected' : '')
        }, (0, _preact.h)("div", {
          onClick: function onClick() {
            return _this4.setSelectedProductArea(productArea);
          },
          onKeyUp: function onKeyUp(e) {
            return e.code === 'Enter' ? _this4.setSelectedProductArea(productArea) : null;
          },
          role: "button",
          className: (0, _classnames.default)('list-item-button', (selectedProductArea === null || selectedProductArea === void 0 ? void 0 : selectedProductArea.id) === productArea.id && selectedProductAreaSectionId === null ? 'selected' : ''),
          tabIndex: 0
        }, (0, _preact.h)("span", {
          className: "product-area-filter__title"
        }, productArea.name)));
      })));
    }
  }]);
  return ProductAreaList;
}(_preact.Component);

var ProductAreaFilter = /*#__PURE__*/function (_Component2) {
  (0, _inherits2.default)(ProductAreaFilter, _Component2);

  var _super2 = _createSuper(ProductAreaFilter);

  function ProductAreaFilter() {
    var _this5;

    (0, _classCallCheck2.default)(this, ProductAreaFilter);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this5 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "state", {
      selectedProductAreaBeforeFiltersApply: null,
      isPortal: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "updatePortalSetting", function (evt, productArea) {
      _this5.setState({
        selectedProductAreaBeforeFiltersApply: productArea,
        isPortal: evt.detail.display
      });
    });
    return _this5;
  }

  (0, _createClass2.default)(ProductAreaFilter, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          productAreas = _this$props.productAreas,
          selectedProductArea = _this$props.selectedProductArea,
          selectedProductAreaSectionId = _this$props.selectedProductAreaSectionId;
      var _this$state2 = this.state,
          isPortal = _this$state2.isPortal,
          selectedProductAreaBeforeFiltersApply = _this$state2.selectedProductAreaBeforeFiltersApply;
      return (0, _preact.h)("div", null, (0, _preact.h)(ProductAreaList, {
        selectedProductArea: selectedProductArea,
        selectedProductAreaSectionId: selectedProductAreaSectionId,
        selectedProductAreaBeforeFiltersApply: selectedProductAreaBeforeFiltersApply,
        updatePortalSetting: this.updatePortalSetting,
        productAreas: productAreas
      }), isPortal && (0, _preact.h)(_preactPortal.default, {
        into: ".instant-search__results-wrapper-filters"
      }, (0, _preact.h)(ProductAreaList, {
        selectedProductArea: selectedProductArea,
        selectedProductAreaSectionId: selectedProductAreaSectionId,
        selectedProductAreaBeforeFiltersApply: selectedProductAreaBeforeFiltersApply,
        updatePortalSetting: this.updatePortalSetting,
        productAreas: productAreas
      })));
    }
  }]);
  return ProductAreaFilter;
}(_preact.Component);

exports.ProductAreaFilter = ProductAreaFilter;
var _default = ProductAreaFilter;
exports.default = _default;